
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vip_rating",
      function () {
        return require("private-next-pages/vip_rating.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vip_rating"])
      });
    }
  